import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

export function EmptyState({
  title,
  description,
  icon,
  action,
}: {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-12 px-4 text-slate-500">
      <div className="mb-3 p-3 bg-bb-lilac/20 text-bb-navy">
        {icon ?? <Inbox size={24} />}
      </div>
      <h3 className="text-base font-semibold text-slate-800">{title}</h3>
      {description ? <p className="text-sm mt-1 max-w-md">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
